import { Locale } from '@finxone-platform/shared/enums';
import { AlertData, AlertDetails } from '@finxone-platform/shared/sys-config-types';

export class GetProjectAlerts {
  static readonly type = '[Project] SetActiveProject';
  constructor(public params: { locale: Locale; key: string }, public projectId: string) {}
}

export class UpdateProjectAlerts {
  static readonly type = '[Project] SetActiveProject';
  constructor(
    public payload: {
      locale: string;
      key: string;
      translationKey: string;
      name: string;
      title: string;
      description: string;
      isDefault: boolean;
      value?: { [errorCode: string]: AlertDetails };
    },
    public projectId: string,
  ) {}
}

export class UpdateAlertBasedOnKey {
  static readonly type = '[Project] UpdateAlertBasedOnKey';
  constructor(public alertData: AlertData) {}
}

export class UpdateIsDefault {
  static readonly type = '[Project] UpdateIsDefault';
  constructor(public isDefault: boolean) {}
}
